module.exports = __webpack_public_path__ + "static/media/lumin-min.379bad94.png";